/**
 * Transition
 *
 * @class
 */
class Transition {
  /**
   * @constructor
   *
   * @param { jQuery } $element
   * @param { int } duration in ms
   * @param { int } delay in ms
   */
  constructor($element, duration, delay = 0) {
    this._$element = $element;
    this._animInClass = '';
    this._animOutClass = '';
    this._duration = duration;
    this._delay = delay;
    this._animTimeout = null;
  }

  // Public

  /**
   * Handles the in animation
   *
   * @param { Function } callback
   */
  in(callback = null) {
    setTimeout(() => {
      this._$element.addClass('visible');
      this.animating(true);
      this._$element.removeClass(this.animOutClass);
      this._$element.addClass(this.animInClass);

      this._animTimeout = setTimeout(() => {
        this.animating(false);
        this._$element.removeClass(this.animInClass);

        if (typeof callback === 'function') {
          callback();
        }
      }, this._duration);
    }, this._delay);
  }

  /**
   * Handles the out animation
   *
   * @param { Function } callback
   */
  out(callback = null) {
    this.animating(true);
    this._$element.removeClass(this.animInClass);
    this._$element.addClass(this.animOutClass);

    this._animTimeout = setTimeout(() => {
      this.animating(false);
      this._$element.removeClass('visible');
      this._$element.removeClass(this.animOutClass);

      if (typeof callback === 'function') {
        callback();
      }
    }, this._duration);
  }

  /**
   * Changes the states based on the given boolean
   *
   * @param { Boolean } animating
   */
  animating(animating = true) {
    if (animating) {
      this._$element.css('animation-duration', `${this._duration}ms`);
    } else {
      this._$element.css('animation-duration', '');
    }

    this._$element.toggleClass('t-animated', animating);
  }

  // Getters

  /**
   * Gets the animInClass property
   *
   * @return { String } this._animInClass
   */
  get animInClass() {
    return this._animInClass;
  }

  /**
   * Gets the animOutClass property
   *
   * @return { String } this._animOutClass
   */
  get animOutClass() {
    return this._animOutClass;
  }

  /**
   * Gets the delay property
   *
   * @return { int } this._delay
   */
  get delay() {
    return this._delay;
  }
}

export default Transition;
